import { Layout, Seo } from '@foxrenderfarm/common'
import { ArtTemplateContext } from '../../interface'
import { ArtContent } from './components/art-content'
import { SearchBanner } from '../../components'
import { LOCALE } from '@foxrenderfarm/internals'
import { useEffect, useState } from 'react'

interface Props {
  pageContext: ArtTemplateContext
}

const ArtPage = ({ pageContext }: Props) => {
  const { dirs, seo, title } = pageContext
  const [pathname, setPathname] = useState('')

  useEffect(() => {
    setPathname(window.location.pathname.substring(1, window.location.pathname.length - 1))
  }, [])

  return (
    <Layout>
      <Seo
        title={seo?.title || `${title} - Fox Renderfarm Support Center`}
        description={seo?.description || `About ${title} from Fox Renderfarm support center.`}
        keywords={seo?.keywords ? seo.keywords.join(',') : ''}
        sharePostSlug={`${pathname}/`}
        lang={LOCALE.EN}
      />
      <SearchBanner dirs={dirs} />
      <ArtContent pageContext={pageContext} />
    </Layout>
  )
}

export default ArtPage
